import type { Listing, Locale } from "@agentsaas/protocol";
import { formatMicroUsd } from "../app/format";

/** 市场的纯逻辑（可单测） */

export type Pricing = Listing["pricing"];

/** 租用总价（micro-USD）：per_rental = 单价；per_day = 单价 × 天数；free = 0 */
export function rentalPrice(p: Pricing, days: number): number {
  if (p.model === "free") return 0;
  return p.model === "per_day" ? p.priceMicroUsd * Math.max(1, Math.floor(days)) : p.priceMicroUsd;
}

/** 价格展示所需的参数；文案 key 由调用方翻译：market.price.<model> */
export function priceParams(p: Pricing, locale: Locale): { key: string; price: string } {
  return { key: `market.price.${p.model}`, price: formatMicroUsd(p.priceMicroUsd, locale) };
}

/** 评分 → 五颗星中亮几颗（四舍五入到 0.5） */
export function starFill(rating: number | null): number {
  if (rating === null) return 0;
  return Math.round(Math.min(5, Math.max(0, rating)) * 2) / 2;
}

export const LISTING_TONE = { draft: "neutral", pending_review: "warning", published: "success", suspended: "danger" } as const;

/** 美元字符串 → micro-USD（上架定价用）；非法返回 null */
export function parseUsd(v: string): number | null {
  const s = v.trim();
  if (!s) return null;
  const n = Number(s);
  return Number.isFinite(n) && n >= 0 ? Math.round(n * 1_000_000) : null;
}
